var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"past-letters"}},[_c('h1',{staticClass:"german"},[_vm._v("Ihre bisherigen Briefe")]),_c('h1',{staticClass:"arabic"},[_vm._v("رسائلك السابقة")]),_vm._l((_vm.t0),function(letter){return _c('past-letter',{key:letter.id,class:[
      letter.type,
      {
        reader: !letter.by_me,
        writer: letter.by_me,
        patient: letter.by.actsAsPatient,
        therapist: letter.by.actAsTherapist,
      } ],attrs:{"value":letter}})}),_vm._l((_vm.t1),function(letter){return _c('past-letter',{key:letter.id,class:[
      letter.type,
      {
        reader: !letter.by_me,
        writer: letter.by_me,
        patient: letter.by.actsAsPatient,
        therapist: letter.by.actAsTherapist,
      } ],attrs:{"value":letter}})}),_vm._l((_vm.allLettersExceptT0AndT1),function(letter){return _c('past-letter',{key:letter.id,class:[
      letter.type,
      {
        reader: !letter.by_me,
        writer: letter.by_me,
        patient: letter.by.actsAsPatient,
        therapist: letter.by.actAsTherapist,
      } ],attrs:{"value":letter}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }